import { Component, inject, Input } from '@angular/core';
import { AutoConfigLayer } from '../../../models/auto-config';
import { ConfigurationFieldsAdapterService } from '../../configuration-tab/configuration-fields-adapter.service';
import { ObjectType } from '../../configuration-tab/enums/object-types.enum';

@Component({
  selector: 'mee-auto-config-layer',
  templateUrl: './auto-config-layer.component.html',
  styleUrls: ['./auto-config-layer.component.scss']
})
export class AutoConfigLayerComponent {
  @Input() layer: AutoConfigLayer;
  @Input() displayWithSourceName: boolean;

  private configurationFieldsAdapterService = inject(ConfigurationFieldsAdapterService);

  getLayerIconByType(type: ObjectType): string {
    return this.configurationFieldsAdapterService.getObjectTypeIconPath(type);
  }
}
